import React from 'react';
import Modal from 'react-modal';
import { AiOutlineClose } from 'react-icons/ai';
import { IoIosCloseCircle } from "react-icons/io";

const NotInterestedModal = ({
  isOpen,
  onRequestClose,
  selectedStudent,
  isUpdate,
  isUpload,
  formData,
  setFormData,
  selectedCourses,
  setSelectedCourses,
  dropdownValue,
  setDropdownValue,
  canOnlySelectHigherInterest,
  loadingSubmit,
  handleChange,
  handleSelectChange,
  handleRemoveTag,
  handleSubmit,
  memberType,
  courses,
  districts,
}) => {
  const isEditable = isUpdate || isUpload;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Student Details"
      className="mx-auto my-10 mt-[100px] max-h-[85vh] max-w-full sm:max-w-4xl bg-white rounded-lg shadow-lg overflow-auto"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="sticky top-0 z-10 bg-white px-8 py-4">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-semibold">
            {isUpdate ? 'Edit Student' : isUpload ? 'Add Student' : 'Student Details'}
          </h2>
          <div>
            {
              !(isUpdate || isUpload) && (
                <button
                  className={`px-4 py-2 rounded-lg text-white mr-4 ${formData.is_interested !== "Most Interested" ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'}`}
                  disabled={formData.is_interested !== "Most Interested"}
                >
                  Send Mail
                </button>
              )
            }
            {
              !(isUpdate || isUpload) && (
                <button
                  className={`px-4 py-2 rounded-lg text-white mr-4 ${formData.is_interested !== "Most Interested" ? 'bg-gray-300 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'}`}
                  disabled={formData.is_interested !== "Most Interested"}
                >
                  Send WhatsApp Message
                </button>
              )
            }
            <button onClick={onRequestClose}>
              <AiOutlineClose className="w-6 h-6 text-gray-600 hover:text-gray-800 transition duration-200" />
            </button>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 sm:p-8">
        <div className="flex flex-col">
          <label htmlFor="student_name" className="flex items-center">Student Name<span className='ml-1 text-red-600'>*</span></label>
          <input
            type="text"
            id="student_name"
            name="student_name"
            value={formData.student_name}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
            required
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="gender" className="flex items-center">Gender</label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="father_name" className="flex items-center">Father Name</label>
          <input
            type="text"
            id="father_name"
            name="father_name"
            value={formData.father_name}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="mobile_number1" className="flex items-center">Mobile Number 1<span className='ml-1 text-red-600'>*</span></label>
          <input
            type="tel"
            id="mobile_number1"
            name="mobile_number1"
            value={formData.mobile_number1}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 10) {
                setFormData((prev) => ({ ...prev, mobile_number1: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
            required
            pattern="\d{10}"
            title="Mobile number must be exactly 10 digits."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="mobile_number2" className="flex items-center">Mobile Number 2:</label>
          <input
            type="tel"
            id="mobile_number2"
            name="mobile_number2"
            value={formData.mobile_number2}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 10) {
                setFormData((prev) => ({ ...prev, mobile_number2: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
            pattern="\d{10}"
            title="Mobile number must be exactly 10 digits."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="email" className="flex items-center">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="aadhar_number" className="flex items-center">Aadhar Number:</label>
          <input
            type="text"
            id="aadhar_number"
            name="aadhar_number"
            value={formData.aadhar_number}
            onChange={(e) => {
              const rawValue = e.target.value.replace(/-/g, '');
              const formattedValue = rawValue
                .replace(/\D/g, '')
                .replace(/(\d{4})(?=\d)/g, '$1-');
              if (formattedValue.length <= 14) {
                setFormData((prev) => ({ ...prev, aadhar_number: formattedValue }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
            pattern="(\d{4}-\d{4}-\d{4})"
            title="Aadhar number must be in the format 1234-5678-9012."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="state" className="flex items-center">State</label>
          <input
            type="text"
            id="state"
            name="state"
            value={formData.state}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="district" className="flex items-center">District</label>
          <select
            id="district"
            name="district"
            value={formData.district}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          >
            <option value="">Select District</option>
            {districts.map((district, index) => (
              <option key={index} value={district}>{district}</option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="city" className="flex items-center">City:</label>
          <input
            type="text"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="address" className="flex items-center">Address:</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="pincode" className="flex items-center">Pincode:</label>
          <input
            type="text"
            id="pincode"
            name="pincode"
            value={formData.pincode}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 6) {
                setFormData((prev) => ({ ...prev, pincode: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
            pattern="\d{6}"
            title="Pincode must be exactly 6 digits."
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="course" className="flex items-center">Course</label>
          <input
            type="text"
            id="course"
            name="course"
            value={formData.course}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="clg_name" className="flex items-center">College</label>
          <input
            type="text"
            id="clg_name"
            name="clg_name"
            value={formData.clg_name}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="inter_percentage" className="flex items-center">Intermediate Percentage/CGPA</label>
          <input
            type="text"
            id="inter_percentage"
            name="inter_percentage"
            value={formData.inter_percentage}
            onChange={(e) => {
              const value = e.target.value;
              const regex = /^(\d+(\.\d*)?|\.\d+)?$/;
              if (regex.test(value) || value === '') {
                setFormData((prev) => ({ ...prev, inter_percentage: value }));
              }
            }}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="program_type" className="flex items-center">Program Type</label>
          <select
            id="program_type"
            name="program_type"
            value={formData.program_type}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          >
            <option value="">Select Program Type</option>
            <option value="UG">UG</option>
            <option value="PG">PG</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="ug_pg_course" className="flex items-center">UG/PG Course</label>
          <select
            id="ug_pg_course"
            name="ug_pg_course"
            value={dropdownValue}
            onChange={handleSelectChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course} value={course}>{course}</option>
            ))}
          </select>

          <div className="flex flex-wrap gap-2 mt-2">
            {selectedCourses.map((course) => (
              <div key={course} className="flex items-center bg-blue-100 rounded-full px-3 py-1">
                <span>{course}</span>
                <button
                  type="button"
                  className="ml-2 text-red-500"
                  disabled={!isEditable}
                  onClick={() => handleRemoveTag(course)}
                >
                  <IoIosCloseCircle className='text-blue-800 w-5 h-5' />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          <label htmlFor="call_duration" className="flex items-center text-lg font-semibold text-gray-700 mb-2">
            Call Duration
          </label>
          <div className="flex flex-row space-x-2">
            <div className="relative">
              <input
                type="text"
                id="hours"
                name="hours"
                value={formData.hours?.padStart(2, '0') || '00'}
                className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                disabled
              />
              <span className="absolute right-2 top-2 text-gray-500 font-bold">h</span>
            </div>
            <div className="flex items-center text-gray-500 font-bold">:</div>
            <div className="relative">
              <input
                type="text"
                id="minutes"
                name="minutes"
                value={formData.minutes?.padStart(2, '0') || '00'}
                className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                disabled
              />
              <span className="absolute right-2 top-2 text-gray-500 font-bold">m</span>
            </div>
            <div className="flex items-center text-gray-500 font-bold">:</div>
            <div className="relative">
              <input
                type="text"
                id="seconds"
                name="seconds"
                value={formData.seconds?.padStart(2, '0') || '00'}
                className="h-10 bg-gray-100 border border-gray-300 text-gray-900 rounded-md w-16 text-center shadow-sm focus:outline-none cursor-not-allowed"
                disabled
              />
              <span className="absolute right-2 top-2 text-gray-500 font-bold">s</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label htmlFor="call_status" className="flex items-center">Call Status<span className='ml-1 text-red-600'>*</span></label>
          <select
            id="call_status"
            name="call_status"
            value={formData.call_status}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${formData.call_status === 'Contacted' || !isEditable ? 'cursor-not-allowed' : ''}`}
            disabled={formData.call_status === 'Contacted' || !isEditable}
            required
          >
            <option value="">Select Status</option>
            <option value="Contacted">Contacted</option>
            <option value="Not Answered">Not Answered</option>
          </select>
        </div>

        <div className="flex flex-col col-span-1 sm:col-span-2">
          <label htmlFor="remarks" className="flex items-center">Remarks:</label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            className={`p-2 bg-slate-100 border rounded ${!isEditable && 'cursor-not-allowed'}`}
            disabled={!isEditable}
            rows={2}
          />
        </div>

<div className="flex flex-col col-span-1 sm:col-span-2">
  <div className="flex">
    <label className="flex items-center mr-4">
      <input
        type="radio"
        name="is_interested"
        value="Not Interested"
        checked={formData.is_interested === 'Not Interested'}
        onChange={handleChange}
        className="mr-2"
        disabled={!(isUpdate || isUpload)} // Only disable in view mode
      />
      Not Interested
    </label>

    <label className="flex items-center mr-4">
      <input
        type="radio"
        name="is_interested"
        value="Interested"
        checked={formData.is_interested === 'Interested'}
        onChange={handleChange}
        className="mr-2"
        disabled={!(isUpdate || isUpload)} // Only disable in view mode
      />
      Interested
    </label>

    <label className="flex items-center mr-4">
      <input
        type="radio"
        name="is_interested"
        value="Most Interested"
        checked={formData.is_interested === 'Most Interested'}
        onChange={handleChange}
        className="mr-2"
        disabled={!(isUpdate || isUpload)} // Only disable in view mode
      />
      Most Interested
    </label>

    <label className="flex items-center mr-4">
      <input
        type="radio"
        name="is_interested"
        value="Call Back"
        checked={formData.is_interested === 'Call Back'}
        onChange={handleChange}
        className="mr-2"
        disabled={!(isUpdate || isUpload)} // Only disable in view mode
      />
      Call Back
    </label>

    <label className="flex items-center mr-4">
      <input
        type="radio"
        name="is_interested"
        value="Others"
        checked={formData.is_interested === 'Others'}
        onChange={handleChange}
        className="mr-2"
        disabled={!(isUpdate || isUpload)} // Only disable in view mode
      />
      Others
    </label>
  </div>

          <div className="flex items-center mt-4">
            {formData.is_interested === 'Call Back' && (
              <div className="mt-2 flex items-center justify-center">
                <label htmlFor="call_back_reason" className="block mb-2">Call Back Reason<span className='ml-1 text-red-600'>*</span>:</label>
                <select
                  id="call_back_reason"
                  name="call_back_reason"
                  value={formData.call_back_reason || ''}
                  onChange={handleChange}
                  className="p-2 border ml-4 border-gray-300 rounded"
                  required={formData.is_interested === 'Call Back'}
                >
                  <option value="">Select Reason</option>
                  <option value="IPE Exams">IPE Exams</option>
                  <option value="Jee Mains Results">JEE Mains Results</option>
                  <option value="Jee Mains-2 Results">JEE Mains-2 Results</option>
                  <option value="Eamcet Results">EAMCET Results</option>
                  <option value="IPE Results">IPE Results</option>
                  <option value="Supply Exams">Supply Exams</option>
                  <option value="Supply Results">Supply Results</option>
                  <option value="EOD">EOD</option>
                </select>
              </div>
            )}

            {formData.is_interested === 'Others' && (
              <div className="mt-2 flex items-center justify-center">
                <label htmlFor="other_reasons" className="block mb-2">Other Reason<span className='ml-1 text-red-600'>*</span>:</label>
                <select
                  id="other_reasons"
                  name="other_reasons"
                  value={formData.other_reasons || ''}
                  onChange={handleChange}
                  className="p-2 border ml-4 border-gray-300 rounded"
                  required={formData.is_interested === 'Others'}
                >
                  <option value="">Select Reason</option>
                  <option value="Wrong Number">Wrong Number</option>
                  <option value="Not Reachable">Not Reachable</option>
                  <option value="Number Not Working">Number Not Working</option>
                  <option value="Call Declined">Call Declined</option>
                  <option value="Busy">Busy</option>
                  <option value="Switched Off">Switched Off</option>
                  <option value="Incoming Calls Stopped">Incoming Calls Stopped</option>
                </select>
              </div>
            )}
          </div>
        </div>

        {(isUpdate || isUpload) && (
          <div className="flex flex-col col-span-1 sm:col-span-2">
            <button
              type="submit"
              className={`bg-blue-600 text-white px-4 py-2 rounded ${loadingSubmit && 'cursor-not-allowed'}`}
              disabled={loadingSubmit}
            >
              {loadingSubmit ? 'Submitting...' : (isUpdate ? 'Update Student' : 'Add Student')}
            </button>
          </div>
        )}
      </form>
    </Modal>
  );
};

export default NotInterestedModal;